import { useCallback } from 'react';
import { type NavigateOptions, type To, useNavigate } from 'react-router-dom';

/**
 * View Transition API를 활용한 페이지 이동 훅
 *
 * @example
 * const { navigateWithTransition } = useViewTransition();
 *
 * navigateWithTransition('/edit/123');
 * navigateWithTransition('/edit/123', { replace: true });
 */
const useViewTransition = () => {
  const navigate = useNavigate();

  const navigateWithTransition = useCallback(
    (to: To, options?: NavigateOptions) => {
      if (!document.startViewTransition) {
        navigate(to, options);
        return;
      }

      document.startViewTransition(() => {
        navigate(to, options);
      });
    },
    [navigate]
  );

  return { navigateWithTransition };
};

export default useViewTransition;
